/* @flow weak */

const React = require('react');
const _ = require('lodash');

const FormRenderer = React.createClass({
  propTypes: {
    fields: React.PropTypes.array
  },

  formId: null,

  componentWillMount() {
    this.formId = Date.now();
  },

  validateForm() {
    let validated = true;

    // @TODO: just very basic validation for now, could be a lot more robust
    for (let i = 0; i < this.props.fields.length; i++) {
      let field = this.props.fields[i];
      if (field.required && !document.getElementById(`${field.name}-${this.formId}`).value) {
        validated = false;
        break;
      }
    }

    return validated;
  },

  clearForm() {
    _.each(this.props.fields, field => {
      document.getElementById(`${field.name}-${this.formId}`).value = '';
    });
  },

  getFormData() {
    let formData = {};

    _.each(this.props.fields, field => {
      formData[field.name] = document.getElementById(`${field.name}-${this.formId}`).value;
    });

    return formData;
  },

  render() {
    return (
      <div className="uc-form">
        {_.map(this.props.fields, (field, i) => {
          return (
            <label key={i} htmlFor={`${field.name}-${this.formId}`}>
              {field.label}{field.required ? <span style={{ color: 'red' }}>*</span> : null}:
              <input id={`${field.name}-${this.formId}`} value={field.value} type={field.type} />
            </label>
          );
        })}
      </div>
    );
  }
});

module.exports = FormRenderer;


// WEBPACK FOOTER //
// ./src/base/scripts/components/renderers/FormRenderer.jsx